import { handleConcomShopLoad } from "../cwv-handlers/handleConcomShop";
import handleMeetTheTeamLoad from "../cwv-handlers/handleMeetTheTeamLoad";
import { handleStickyNavCollapse } from "../cwv-handlers/handleStickyNavCollapse";
import { getPageSettings } from "./pageSettings";

const pageTemplate = getPageSettings('pagetemplate');

export function cwvHandler() {
	const currentRoute = globalThis.location?.pathname || '/not-found/';
	const actionRoutes = {
		'/gift-certificates/': { method: handleStickyNavCollapse },
		'/why-hire-us/': { method: handleStickyNavCollapse },
		'/residential/dryer-vent-cleaning-services/dryer-vent-service-and-repair/': { method: handleStickyNavCollapse },
		'/leadership-team/': {method: handleMeetTheTeamLoad}
	};

	// navMenuGlobalStickyHandler(); Temporarily removed due to compatability with nbly company site.
	handleConcomShopLoad();
	handleMeetTheTeamLoad();

	const routeSplit = currentRoute.split('/').filter(Boolean);
	if (routeSplit.length > 0) {
		for (const segment of routeSplit) {
			const key = `/${segment}/` as keyof typeof actionRoutes;
			if (actionRoutes[key]) {
				actionRoutes[key].method();
				break;
			}
		}
	}
}